const targetEnvs = {
  azureDEV: {
    ssoPath: 'https://dev-login.pathway.ey.com/access/imlv2',
    ssoPathLogout: 'https://dev-login.pathway.ey.com/access/logout?mode=',
  },
  azureDEV2: {
    ssoPath: 'https://dev2-login.pathway.ey.com/access/imlv2',
    ssoPathLogout: 'https://dev2-login.pathway.ey.com/access/logout?mode=',
  },
  azureDEV3: {
    ssoPath: 'https://dev3-login.pathway.ey.com/access/imlv2',
    ssoPathLogout: 'https://dev3-login.pathway.ey.com/access/logout?mode=',
  },
  azureDEVPOC: {
    ssoPath: 'https://dev-login.pathway.ey.com/access/imlpoc',
    ssoPathLogout: 'https://dev-login.pathway.ey.com/access/logout?mode=',
  },
  azureQA: {
    ssoPath: 'https://qa-login.pathway.ey.com/access/imlv2',
    ssoPathLogout: 'https://qa-login.pathway.ey.com/access/logout?mode=',
  },
  azureQA2: {
    ssoPath: 'https://qa2-login.pathway.ey.com/access/imlv2',
    ssoPathLogout: 'https://qa2-login.pathway.ey.com/access/logout?mode=',
  },
  azureQA3: {
    ssoPath: 'https://qa3-login.pathway.ey.com/access/imlv2',
    ssoPathLogout: 'https://qa3-login.pathway.ey.com/access/logout?mode=',
  },
  azureQAPOC: {
    ssoPath: 'https://qa-login.pathway.ey.com/access/imlpoc',
    ssoPathLogout: 'https://qa-login.pathway.ey.com/access/logout?mode=',
  },
  azureUAT: {
    ssoPath: 'https://uat-login.pathway.ey.com/access/imlv2',
    ssoPathLogout: 'https://uat-login.pathway.ey.com/access/logout?mode=',
  },
  azureUAT2: {
    ssoPath: 'https://uat2-login.pathway.ey.com/access/imlv2',
    ssoPathLogout: 'https://uat2-login.pathway.ey.com/access/logout?mode=',
  },
  azureUATDE: {
    ssoPath: 'https://uat-login-pathway-eu.ey.com/access/imleu',
    ssoPathLogout: 'https://uat-login-pathway-eu.ey.com/access/logout?mode=',
  },
  azureSTG: {
    ssoPath: 'https://stg-login.pathway.ey.com/access/imlv2',
    ssoPathLogout: 'https://stg-login.pathway.ey.com/access/logout?mode=',
  },
  azurePROD: {
    ssoPath: 'https://login.pathway.ey.com/access/iml',
    ssoPathLogout: 'https://login.pathway.ey.com/access/logout?mode=',
  },
  azurePRODDE: {
    ssoPath: 'https://login-pathway-eu.ey.com/access/imleu',
    ssoPathLogout: 'https://login-pathway-eu.ey.com/access/logout?mode=',
  },
  azureDEMO: {
    ssoPath: 'https://demo-login.pathway.ey.com/access/IMLV2',
    ssoPathLogout: 'https://demo-login.pathway.ey.com/access/logout?mode=',
  },
  azureDEMOEU: {
    ssoPath: 'https://dev-login.pathway.ey.com/access/IMLV2EU',
    ssoPathLogout: 'https://dev-login.pathway.ey.com/access/logout?mode=',
  },
  local: {
    ssoPath: 'https://localhost:44385/',
  },
};

const targetEnv = process.env.TARGET_ENV || 'local';
export const redirectUrls = targetEnvs[targetEnv];
